import shopQueries from '@apis/queries/shopQueries';
import userQueries from '@apis/queries/userQueries';
import UserApi from '@apis/user/UserApi';
import useToast from '@hooks/ui/useToast';
import { ErrorResponse } from '@models/error';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

function useToggleLocationAgreement() {
    const { t } = useTranslation('accountSetting');
    const toast = useToast();
    const queryClient = useQueryClient();
    const { data: user } = useQuery(userQueries.detail());
    const { mutate } = useMutation({
        mutationFn: UserApi.toggleLocationAgreement,
        onSuccess() {
            queryClient.invalidateQueries({ queryKey: userQueries._def, type: 'all' });
            queryClient.invalidateQueries({ queryKey: shopQueries._def, type: 'all' });
        },
        onError(e: AxiosError<ErrorResponse>) {
            toast.error(e.response?.data.message || t('toast.unknownError'));
        },
    });

    const toggleLocationAgreement = () => {
        mutate(!user?.locationAgreed);
    };

    return {
        toggleLocationAgreement,
        locationAgreed: user?.locationAgreed,
    };
}

export default useToggleLocationAgreement;
